import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import {
  getEmployeeSalesReportTableProps,
  EmployeeSalesReportTableProps,
} from './employeeSalesReportTableProps';

export const ReportTable = ({
  venueId,
  fromDate,
  toDate,
  reportData,
}: EmployeeSalesReportTableProps) => {
  const props = useMemo(
    () => getEmployeeSalesReportTableProps({ venueId, fromDate, toDate, reportData }),
    [venueId, fromDate, toDate, reportData],
  );

  return <Reconnect name="ReportTable" props={props} />;
};
